'use client';

import {
    ReactNode,
    createContext,
    useContext,
    useEffect,
    useState,
} from 'react';

import { useAuth } from '@r123/auth';

import gtag from '@/modules/gtag/gtag';

import { ListingDetail } from '../_presentation/type';
import { trackImpression } from './withImpressionTracker';

const ListingTrackerGAContext = createContext<ListingTrackerGAContext>({
    listingTrackerGA: undefined,
    listingTrackerGA4New: undefined,
});

export function ListingTrackerGAProvider({
    listing,
    children,
}: ListingTrackerGAProviderProps) {
    const { authProfile } = useAuth();
    const [isAuthProfileDefined, setIsAuthProfileDefined] = useState(false);

    useEffect(() => {
        if (authProfile !== undefined) {
            setIsAuthProfileDefined(true);
        }
    }, [authProfile]);

    useEffect(() => {
        setTimeout(() => {
            let impressionTracker: ListingImpression;
            if (isAuthProfileDefined) {
                impressionTracker = trackImpression(listing, authProfile);
            } else {
                impressionTracker = trackImpression(listing);
            }
            gtag.dataLayerPush(impressionTracker.pageview);
            // NOTE: move impression tracker to listing info component
            // firing when title rendered
            // gtag.dataLayerPush(impressionTracker.impression);
        }, 2_000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthProfileDefined]);

    const context: ListingTrackerGAContext = {
        listingTrackerGA: trackImpression(listing, authProfile).impression,
        listingTrackerGA4New: listing,
    };

    return (
        <ListingTrackerGAContext.Provider value={context}>
            {children}
        </ListingTrackerGAContext.Provider>
    );
}

export function useListingTrackerGA(): ListingTrackerGAContext {
    return useContext(ListingTrackerGAContext);
}

type ListingTrackerGAContext = {
    listingTrackerGA?: MainTracker;
    listingTrackerGA4New?: ListingDetail;
};

type ListingTrackerGAProviderProps = {
    listing: ListingDetail;
    children: ReactNode;
};
